{
  "name": "salonboarding",
  "version": "2026.1.1",
  "description": "SAL Onboarding Forms",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "prebuild": "node scripts/version-write.js",
    "build": "npm run prebuild && ng build && npm run sentry:sourcemaps",
    "build:uat": "npm run prebuild && ng build --configuration uat",
    "build:develop": "npm run prebuild && ng build --configuration development",
    "build:prod": "npm run prebuild && ng build --configuration production && npm run sentry:sourcemaps",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "sentry:sourcemaps": "SENTRY_AUTH_TOKEN=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 sentry-cli sourcemaps inject --org avionics --project sal-onboarding ./dist/salonboarding/browser/ && SENTRY_AUTH_TOKEN=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 sentry-cli sourcemaps upload --org avionics --project sal-onboarding ./dist/salonboarding/browser/"
  },
  "private": true,
  "engines": {
    "npm": ">=7.0.0",
    "node": ">=16.0.0"
  },
  "dependencies": {
    "@angular/animations": "^21.0.1",
    "@angular/cdk": "^21.0.1",
    "@angular/common": "^21.0.1",
    "@angular/compiler": "^21.0.1",
    "@angular/core": "^21.0.1",
    "@angular/forms": "^21.0.1",
    "@angular/platform-browser": "^21.0.1",
    "@angular/platform-browser-dynamic": "^21.0.1",
    "@angular/router": "^21.0.1",
    "@angular/service-worker": "^21.0.1",
    "@ng-select/ng-select": "^21.0.0",
    "@sentry/angular": "^10.27.0",
    "@sentry/cli": "^2.58.2",
    "@uppy/core": "^4.5.3",
    "@uppy/transloadit": "^4.3.3",
    "angular-ng-stepper": "^2.0.0",
    "bootstrap": "^5.3.8",
    "crypto-js": "^4.2.0",
    "ng-connection-service": "^13.0.2",
    "ngx-toastr": "^19.1.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular/build": "^21.0.1",
    "@angular/cli": "^21.0.1",
    "@angular/compiler-cli": "^21.0.1",
    "@types/crypto-js": "^4.2.2",
    "@types/jasmine": "~5.1.0",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.9.3"
  }
}
